var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M4 16.5h1.333M16 4.5v1.333M26.667 16.5H28M7.467 7.967 8.4 8.9m16.133-.933L23.6 8.9M12.933 23.167h6.134M12 21.833a6.666 6.666 0 1 1 8 0 4.667 4.667 0 0 0-1.333 4 2.667 2.667 0 0 1-5.334 0 4.666 4.666 0 0 0-1.333-4Z","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})
}
var staticRenderFns = []

export { render, staticRenderFns }